import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { SurveyProvider } from './context/SurveyContext';
import ValidatePage      from './pages/ValidatePage';
import PreferencesPage   from './pages/PreferencesPage';
import ConfirmationPage  from './pages/ConfirmationPage';

/**
 * App
 * Route definitions for the patient preference survey SPA.
 *
 * Routes:
 *   /validate?pid=<token>  — Step 1: identity verification
 *   /preferences           — Step 2: communication preferences form (guarded)
 *   /done                  — Step 3: confirmation screen
 *   /*                     — Fallback: redirect to /validate
 */
export default function App() {
    const basename = import.meta.env.VITE_APP_BASENAME || undefined;

    return (
        <BrowserRouter basename={basename}>
            <SurveyProvider>
                <Routes>
                    <Route path="/validate"    element={<ValidatePage />} />
                    <Route path="/preferences" element={<PreferencesPage />} />
                    <Route path="/done"        element={<ConfirmationPage />} />
                    <Route path="*"            element={<Navigate to="/validate" replace />} />
                </Routes>
            </SurveyProvider>
        </BrowserRouter>
    );
}
